export const loopArray = ( items, callback, extraData = {} ) => {
	if ( ! items || ! items.length ) {
		return
	}

	return items.map( ( item, index ) => {
		return callback( index, item, extraData )
	} )
}

export const removeValueFromArray = ( value, array ) => {
	return array.filter( item => item !== value )
}



// WEBPACK FOOTER //
// ./utilities/arrays.jsx